export default __webpack_public_path__ + "static/media/ri_more-2-fill.5785ab3a.svg";